import { inject } from "mobx-react";
import React from "react";
import { Route, RouteComponentProps, Switch, useHistory } from "react-router";
import { LanguageSchema } from "./schema";
import {
  CreateView,
  IndexView,
  ShowView,
  withBreadCrumbs
} from "lego-gui-lib/lib";
import i18next from "i18next";
import { observer } from "mobx-react-lite";

export const Languages = {
  url: "/languages",
  handler: (props: RouteComponentProps<any>) => {
    const baseUrl = props.match.url;
    const title = i18next.t("hns:language:domain_plural");
    return withBreadCrumbs(
      { to: baseUrl, children: title },
      <>
        <Switch>
          <Route exact={true} path={baseUrl} component={Index} />
          <Route path={baseUrl + "/create/:id"} component={Create} />
          <Route path={baseUrl + "/create"} component={Create} />
          <Route path={baseUrl + "/:id"} component={Show} />
        </Switch>
      </>
    );
  }
};

const injectDataSource = (comp: any) =>
  inject("language", "i18n")(observer(comp));

export const Index = injectDataSource(({ language, i18n, ...rest }: any) => {
  const title = i18n.t("hns:language:domain", { count: 2 });
  return (
    <IndexView
      dataSource={language.listDataSource}
      {...rest}
      title={title}
      toolbarButtons={{ delete: false, export: true }}
      rowButtons={{ edit: false, delete: true, copy: false, export: true }}
      columns={LanguageSchema}
    />
  );
});

export const Create = injectDataSource(
  ({ language, i18n, match, ...rest }: any) => {
    const title = i18n.t("common:create", { domain: "hns:language:domain" });
    const history = useHistory();
    return withBreadCrumbs(
      { to: match.url + "/edit", children: title },
      <CreateView
        dataSource={language.oneDataSource}
        {...rest}
        title={title}
        fields={LanguageSchema}
        id={match.params}
        goBack={() => history.goBack()}
      />
    );
  }
);

export const Show = injectDataSource(({ language, i18n, match }: any) => {
  const title = i18n.t("common:edit", { domain: "hns:language:domain" });
  const history = useHistory();
  return withBreadCrumbs(
    { to: match.url + "/edit", children: title },
    <ShowView
      dataSource={language.oneDataSource}
      title={title}
      fields={LanguageSchema}
      id={match.params}
      goBack={() => history.goBack()}
    />
  );
});
